"use client";
import { jsx } from "react/jsx-runtime";
import { Dialog } from "@base-ui/react/dialog";
import { Drawer } from "@base-ui/react/drawer";
import { useDialogMode } from "./DialogContext.js";
function DialogPortal({ container: containerProp, ...props }) {
    const mode = useDialogMode();
    const container = containerProp ?? ("u" > typeof document ? document.body : void 0);
    if ('drawer' === mode) return /*#__PURE__*/ jsx(Drawer.Portal, {
        container: container,
        ...props
    });
    return /*#__PURE__*/ jsx(Dialog.Portal, {
        container: container,
        ...props
    });
}
export { DialogPortal };
